import React from "react";
import {
//   BrowserRouter as Router,
  useParams,
} from "react-router-dom";
import Fits from './Fits';
import GDNT from './GDNT';
import EngDrawings from './EngDrawings';
import Symbols from "./Symbols";
import FMEA from "./FMEA";


const ChangeComponents = {
    fits: Fits,
    gdnt: GDNT,
    engdrawings: EngDrawings,
    symbols: Symbols,
    fmea: FMEA,
 
  };

export default function Subtopics(props) {
    // The <Route> that rendered this component has a
    // path of `/topics/:topicId`. The `:topicId` portion
    // of the URL indicates a placeholder that we can
    // get from `useParams()`.
    let { topicId } = useParams();
    
    let MyComponent = ChangeComponents[topicId];
    return (
        <div>
            {/* {topicId} is for testing route names */}
            {/* <h3>{topicId}</h3> */}
            <MyComponent topicId={topicId}/>
      </div>
    );
  }